export const validateCreateMasterKeyForm = (masterFormData) => {
    if (Object.keys(masterFormData).length === 0) {
        return false
    }
    if (masterFormData.name && masterFormData.apiKeyName && masterFormData.keyType && masterFormData.dataType) {
        return true
    } else {
        return false
    }
}